<template>
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		data-icon="ListFilterOutlined"
	>
		<path
			d="M15 3a2 2 0 0 1 2 2v2.15a1.4 1.4 0 0 1-.487 1.061L12 11.792v9.083c0 .578-.432 1.055-.991 1.125l-.142.009c-.197 0-.39-.051-.561-.149l-3.683-2.476C6.227 19.159 6 18.955 6 18.5v-6.71L1.49 8.212a1.4 1.4 0 0 1-.48-.89L1 7.149V5.001a2 2 0 0 1 2-2h12Zm5 14a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h4ZM15 5H2.999L3 7l4.493 3.454c.267.228.453.528.496.872L8 11.5V18l2 1.385v-7.868c0-.35.13-.685.363-.94l.125-.122L15 7V5Zm7 8a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2h6Z"
			fill="currentColor"
		></path>
	</svg>
</template>
